import "@shortsworks/ui/globals.css";
// import './styles/global.css';
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { mainRouter } from "./router";
import { disableReactDevTools } from "@app/utils/disableDevTools";
import { ModalProvider, SidebarProvider } from "@shortsworks/ui";
// import { ModalProvider, useModal } from 'src/components/modals/ModalProvider';

disableReactDevTools();

dayjs.extend(relativeTime);

const initQueryClient = () => {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (err: any) => {
        console.log("error", err);
      },
    }),
    defaultOptions: {
      queries: {
        throwOnError: false,
        refetchOnWindowFocus: false,
        retry: false,
        // retry: (failureCount, error) => {
        //   if ((error as any).data?.success === false || failureCount >= 2) {
        //     return false;
        //   }
        //   return true;
        // },
      },
    },
  });
};

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <QueryClientProvider client={initQueryClient()}>
      <ModalProvider>
        <RouterProvider router={mainRouter} />
      </ModalProvider>
    </QueryClientProvider>
  </StrictMode>,
);
